export { default as MedcardShare } from '~/core/components/MedcardShare/MedcardShare.vue'
